import { mapState } from "vuex";
export default {
  data() {
    return {

    };
  },
  computed: {
    ...mapState(['type', 'loggedIn']),
  },
};